<div
  class="customer-view-tab-item__inner"
  [class.customer-view-tab-item__inner--variant-modal]="variantModal()"
>
  <!-- `block`: in this block container the host would be inline, which sticky doesn't hold.
       Hidden from 768px down: the item stops scrolling there, so the sticky shadow would cling
       to the page's scroll instead and hang mid-screen. -->
  <fr8bot-ui-content-border-shadow
    class="tw:block tw:[@media(max-width:768px)]:hidden"
    [sides]="['top', 'bottom']"
  />
  <ng-content />
</div>
